import { apiInstances } from '../../../../libs';

const { put } = apiInstances.authInstance;

export default function updatePassword({ password, token }) {
  return put(
    '/password/clouder',
    { password },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
